const state = {
    containerDetailFields: [
        {
            key: "pallet_mark",
            label: "板嘜",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "pallet_no",
            label: "板號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "product_code",
            label: "品號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "product_name",
            label: "品名",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "runcard",
            label: "批號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "box_qty",
            label: "箱數",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "pallet_weight",
            label: "棧板重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "re_check",
            label: "即時上櫃狀態",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "detail",
            label: "明細",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    containerDetailItem: [
        // {
        //     pallet_mark: 'BEFT1790001001-01',
        //     product_code: "FSBD084M05D010CFAW21A10X*",
        //     product_name: 'DIN 7984 薄頭內六角孔螺栓 8.8 粗牙全牙 M5-0.8X10mm (0 8.8,OF) 調質+鍍鋅 5um+三價鉻+氫脆烘0小時+8小時白鏽+24小時紅鏽 ASTM F1941',
        //     box_qty: 72,
        //     loading_status: true,
        // },
        // {
        //     pallet_mark: 'BEFT1790001001-02',
        //     product_code: "FSBD084M05D010CFAW21A10X*",
        //     product_name: 'DIN 7984 薄頭內六角孔螺栓 8.8 粗牙全牙 M5-0.8X10mm (0 8.8,OF) 調質+鍍鋅 5um+三價鉻+氫脆烘0小時+8小時白鏽+24小時紅鏽 ASTM F1941',
        //     box_qty: 72,
        //     loading_status: true,
        // },
    ],
    containerDetailQuery: {
        active: false,
        pkg_wko_code: ""
    }
}
const getters = {
    get_containerDetailFields: state => {
        return state.containerDetailFields
    },
    get_containerDetailItem: state => {
        return state.containerDetailItem
    },
    get_containerDetailQuery: state => {
        return state.containerDetailQuery
    },
}
const actions = {
    set_containerDetailFields(context, array) {
        context.commit('SET_CONTAINERDETAILFIELDS', array);
    },
    set_containerDetailItem(context, array) {
        context.commit('SET_CONTAINERDETAILITEM', array);
    },
    clear_containerDetailItem(context) {
        context.commit('CLEAR_CONTAINERDETAILITEM');
    },
    set_containerDetailQuery(context, array) {
        context.commit('SET_CONTAINERDETAILQUERY', array);
    },
    clear_containerDetailQuery(context) {
        context.commit('CLEAR_CONTAINERDETAILQUERY');
    },
}
const mutations = {
    SET_CONTAINERDETAILFIELDS(state, array) {
        state.containerDetailFields = array;
    },
    SET_CONTAINERDETAILITEM(state, array) {
        state.containerDetailItem = array;
    },
    CLEAR_CONTAINERDETAILITEM(state) {
        state.containerDetailItem = [];
    },
    SET_CONTAINERDETAILQUERY(state, data) {
        state.containerDetailQuery = data;
    },
    CLEAR_CONTAINERDETAILQUERY(state) {
        state.containerDetailQuery = {
            active: false,
            pkg_wko_code: ""
        };
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/containerDetail.js